module.exports = __webpack_public_path__ + "static/media/20240530090011_IMG_7492.44b3d4db.JPG";